<template>
  <div class="contact-view-container">
    <div class="header">
    </div>
    <div class="contact">
      <!--a
        href="mailto:nachhaltigkeitsapp@thi.de">nachhaltigkeitsapp@thi.de</a-->
    </div>

    <div class="imprint">
      <p>Impressum</p>
      <pre>
      Impressum
      BÜNDNIS 90/DIE GRÜNEN Kreisverbände Weiden/OPf.
      Vertretungsberechtiger:

      Andrea König (V.i.S.d.P)
      Mooslohstraße 147
      92637 Weiden i. d. OPf.

      Telefon: 0961 - 62514
      E-Mail: andrea.koenig@spanl.de

      Realisierung durch

      Andreas Gmeiner & Nic Dürr, Growing Futures GbR
      Rehbühlstraße 134
      92637 Weiden
       

     <h1>Datenschutzerklärung</h1>

     Wir wissen, dass Sie dem Thema Datenschutz große Bedeutung beimessen.
     Deshalb ist uns der Schutz Ihrer persönlichen Daten ein wichtiges
     Anliegen..

     <h2> Persönliche Daten</h2>
     Persönliche Daten, die Sie uns elektronisch übermitteln, z.B. Ihren
     Namen, Postanschrift, E-Mail-Adresse oder andere persönlichen Angaben,
     werden von uns nur zum jeweils angegebenen Zweck verwendet, sicher
     verwahrt und nicht an Dritte weitergegeben. Wir werden Ihnen nur
     Informationen zuschicken, sofern Sie sich für entsprechende Dienste
     angemeldet haben.

     <h2>Recht auf Widerruf</h2>
     Sie haben jederzeit das Recht auf Widerruf; schicken Sie bitte eine Mail
     an uns. Ich werde Ihre Daten dann umgehend löschen.

     <h2>Links zu anderen Websites</h2>
     Sie finden auf unseren Seiten Links zu anderen Seiten im Internet. Für
     alle diese Links und Banner gilt, dass ich keinerlei Einfluss auf die
     Gestaltung und die Inhalte der gelinkten Seiten haben. Deswegen
     übernehmen wir auch keinerlei Verantwortung für Inhalt, Gestaltung und
     die Datenschutzbestimmungen dieser Seiten.

     <h2>Verwendung von Cookies</h2>
     Es gibt eine Technik, genannt "Cookies", mit deren Hilfe Informationen
     aus einer Website an Ihre Bedürfnisse angepasst werden können. Ein
     Cookie ist ein Datenelement, das eine Website an Ihren Browser schicken
     kann, um es dort auf Ihrem System zu speichern.

     Gelegentlich nutzen auch wir temporäre Cookies, damit wir Sie effektiver
     unterstützen können, wenn Sie auf eine solche Website zurückkommen oder
     um Formulare, vor Missbrauch und SPAM zu schützen. Sie haben jedoch die
     Möglichkeit, Ihren Browser so einzustellen, dass er Sie davon in
     Kenntnis setzt, wenn Sie ein Cookie erhalten. Dann können Sie selbst
     entscheiden, ob Sie das akzeptieren wollen oder nicht.
      </pre>
    </div>

    <div class="privacy">
      <p>Datenschutz</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      key: "value"
    }
  },
  methods: {
    name() {

    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.contact-view-container {
  @include gradient;
  min-height: 100%;
}

.contact {
  margin: 50px 0px;

  a {
    color: $secondary;
    font-size: 20px;
    font-weight: bold;
  }
}

.imprint, .privacy {
  padding: 30px;
  text-align: left;

  pre {
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}
</style>
